import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import unsubscribeTranslations from "../i18n/unsubscribeTranslations";
import getCurrentLang from "../utils/getCurrentLang";
import "./About.css"; 

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const lang = getCurrentLang();
  const t = unsubscribeTranslations[lang] || unsubscribeTranslations["pt"];
  
  // Captura os dados da URL (enviados via Cloud Function no e-mail)
  const uid = searchParams.get("uid");
  const userEmail = searchParams.get("email");

  const [status, setStatus] = useState("idle"); // idle | loading | success | error

  const handleAction = async () => {
    if (!uid) {
      console.error("Erro: UID ausente no link.");
      setStatus("error");
      return;
    }

    setStatus("loading");
    try {
      // 🚀 CHAMADA REAL PARA A SUA CLOUD FUNCTION
      const apiUrl = `https://unsubscribe-mvlmyj7dha-ue.a.run.app?uid=${uid}`;
      
      const response = await fetch(apiUrl, {
        method: 'GET', // A Cloud Function onRequest (GET) processa a query string
        mode: 'cors'   // Importante para funcionar entre domínios (firebaseapp.com -> cloudfunctions.net)
      });

      if (response.ok) {
        console.log("Sucesso: Usuário descadastrado via API.");
        setStatus("success");
      } else {
        throw new Error("Erro na resposta da API");
      }
    } catch (err) {
      console.error("Erro ao processar descadastro via Fetch:", err);
      setStatus("error");
    }
  };

  return (
    <main className="about-wrapper">
      <header className="about-hero">
        <h1 className="about-title">{t.title}</h1>
      </header>

      <div className="about-grid" style={{ gridTemplateColumns: "1fr", maxWidth: "650px", margin: "2rem auto" }}>
        <section className="about-card" style={{ textAlign: "center", padding: "2.5rem 1.5rem" }}>
          
          {status === "success" ? (
            <div className="about-card-content">
              <h2 className="about-card-title" style={{ color: "var(--brand)" }}>{t.success.heading}</h2>
              <p>{t.success.message}</p>
              <a href="/" className="about-subnav-link" style={{ marginTop: "1.5rem", display: "inline-block" }}>
                Voltar ao Início
              </a>
            </div>
          ) : (
            <>
              <h2 className="about-card-title">{t.heading}</h2>
              <div className="about-card-content">
                {userEmail && (
                  <p style={{ fontWeight: "bold", color: "var(--brand-dark)" }}>
                    {userEmail}
                  </p>
                )}
                
                {t.content.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>

              <button 
                onClick={handleAction}
                disabled={status === "loading"}
                className="about-subnav-link"
                style={{ 
                  marginTop: "2rem",
                  background: "var(--brand)", 
                  color: "#fff", 
                  border: "none", 
                  padding: "0.8rem 2.5rem",
                  fontWeight: "bold",
                  cursor: "pointer",
                  opacity: status === "loading" ? 0.6 : 1
                }}
              >
                {status === "loading" ? t.loading : t.button}
              </button>

              {(status === "error" || (!uid && status === "idle")) && (
                <p style={{ color: "#d32f2f", marginTop: "1rem", fontSize: "0.9rem" }}>
                  {uid ? t.error : "Link inválido. Por favor, use o link enviado no seu e-mail."}
                </p>
              )}
            </>
          )}
        </section>
      </div>
    </main>
  );
}